var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Banner'),_c('Fantasy'),_c('Figure'),_c('VisualFeast'),(false)?_c('DoujinStand'):_vm._e(),_c('div',{staticClass:"footer"},[_c('Footer'),_c('Fool')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }